import Vue from "vue";
import InfiniteLoading from "vue-infinite-loading";
import MugenScroll from "vue-mugen-scroll";

import infiniteScroll from "vue-infinite-scroll";

Vue.component("infinite-loading", InfiniteLoading);
Vue.component("mugen-scroll", MugenScroll);

Vue.use(infiniteScroll);
